// @ts-nocheck
import { TABS_IDENTIFIER } from 'pages/masterData/groups/constants';

export const MODEL_NAME = 'organisms/kitsModal';

export const GROUP_MODAL_TABLE_IDS = {
	GROUPS_STORE: 20,
	GROUPS_SKU: 18,
	GROUPS_CUSTOMERS: 10,
};

export const CUSTOMER_DROPDOWN = [
	{ displayName: TABS_IDENTIFIER.STORES, value: TABS_IDENTIFIER.STORES },
	{ displayName: TABS_IDENTIFIER.SKUS, value: TABS_IDENTIFIER.SKUS },
	{ displayName: TABS_IDENTIFIER.CUSTOMERS, value: TABS_IDENTIFIER.CUSTOMERS },
];

export const getTableId = (GroupType) => {
	switch (GroupType) {
		case TABS_IDENTIFIER.SKUS:
			return GROUP_MODAL_TABLE_IDS.GROUPS_SKU;
		case TABS_IDENTIFIER.CUSTOMERS:
			return GROUP_MODAL_TABLE_IDS.GROUPS_CUSTOMERS;
		case TABS_IDENTIFIER.STORES:
		default:
			return GROUP_MODAL_TABLE_IDS.GROUPS_STORE;
	}
};

export const TABLE_ID = 46;

export const MODAL_STEPS = {
	SELECT_PARAMS: 'startGroup',
	SELECT_STORES: 'selectMembers',
	REVIEW: 'reviewGroup',
};
